import React from 'react';
import {
    BrowserRouter as Router,

} from "react-router-dom";
import './App.css';
import DesktopTeamApp from "./desktop/components/Teams/TeamApp";
import MobileTeamApp from "./mobile/components/Teams/TeamApp";
import {useMediaQuery, useTheme} from "@material-ui/core";

function App(props) {
    const {campaign} = props;
    const theme = useTheme();
    const mobileLayout = useMediaQuery(theme.breakpoints.down('xs'));

    function getAppForLayout() {
        const utm = campaign || 'team';
        if (mobileLayout) {
            return <MobileTeamApp utm={utm}/>
        }
        return (<DesktopTeamApp utm={utm}/>);
    }

    return (
            <Router>
                <div className="uclusion-app" style={{scrollSnapType: 'y'}}>
                    {getAppForLayout()}
                </div>
            </Router>
    );
}

export default App;
